/**
 * SVG Polyfill for react-native-svg web compatibility
 * Provides missing DOM APIs that react-native-svg expects
 */

// Ensure Function.prototype.bind exists (this is the likely issue)
if (typeof Function.prototype.bind !== 'function') {
  Function.prototype.bind = function(thisArg) {
    const fn = this;
    const args = Array.prototype.slice.call(arguments, 1);
    return function() {
      return fn.apply(thisArg, args.concat(Array.prototype.slice.call(arguments)));
    };
  };
}

// Polyfill for missing DOM methods that react-native-svg might need
if (typeof window !== 'undefined') {
  // Ensure DOMParser exists
  if (!window.DOMParser) {
    window.DOMParser = function() {
      return {
        parseFromString: function(str, type) {
          // Basic XML/SVG parsing fallback
          try {
            const parser = new (window.DOMParser || function() {});
            if (parser.parseFromString) {
              return parser.parseFromString(str, type || 'text/xml');
            }
          } catch (e) {
            // Fallback
          }
          
          const div = document.createElement('div');
          div.innerHTML = str;
          return {
            documentElement: div.firstChild || div,
            getElementsByTagName: function(tag) {
              return (div.getElementsByTagName && div.getElementsByTagName(tag)) || [];
            }
          };
        }.bind(this)
      };
    };
  }

  // Ensure XMLSerializer exists
  if (!window.XMLSerializer) {
    window.XMLSerializer = function() {
      return {
        serializeToString: function(node) {
          if (node && node.outerHTML) {
            return node.outerHTML;
          }
          if (node && node.innerHTML) {
            return node.innerHTML;
          }
          return '';
        }.bind(this)
      };
    };
  }

  // Ensure document methods exist
  if (typeof document !== 'undefined') {
    // Polyfill for createElementNS if missing
    if (!document.createElementNS) {
      document.createElementNS = function(namespace, tagName) {
        const element = document.createElement(tagName);
        if (element) {
          element.namespaceURI = namespace;
        }
        return element;
      }.bind(document);
    }
  }

  // Ensure console methods exist and have bind
  if (typeof console !== 'undefined') {
    ['log', 'warn', 'error', 'info', 'debug'].forEach(method => {
      if (console[method] && typeof console[method].bind !== 'function') {
        const originalMethod = console[method];
        console[method] = function() {
          return originalMethod.apply(console, arguments);
        };
      }
    });
  }
}

// Export for webpack to process
export default {};